import _ from 'lodash';
import moment from 'moment';

import * as types from './types';

const INITIAL_STATE = {
  selectedForVerification: {},
  applicationFilters: {
    PagingDetails: {
      PageNumber: 1,
      PageSize: 20,
      Filter: [],
      SortColumn: [],
    },
  },
  loading: true,
  error: null,
  isConfirmationReview: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SELECTED_FOR_VERIFICATION_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case types.SAVE_SELECTED_FILTER_OPTION: {
      return {
        ...state,
        isConfirmationReview: action.payload,
      };
    }
    case types.GET_SELECTED_FOR_VERIFICATION:
      action.payload.data.Data.Result.forEach((x, index) => {
        if (!_.isNil(x.HouseHouldSSN) && x.HouseHouldSSN !== '') {
          if (x.HouseHouldSSN.length === 4) {
            x.HouseHouldSSN = `XXX-XX-${x.HouseHouldSSN}`;
          } else {
            x.HouseHouldSSN =
              x.HouseHouldSSN.slice(0, 3) +
              '-' +
              x.HouseHouldSSN.slice(3, 5) +
              '-' +
              x.HouseHouldSSN.slice(5, 9);
          }
        }
        if (x.ExpirationDate !== null && x.ExpirationDate !== '') {
          x.ExpirationDate = moment(x.ExpirationDate, 'MM/DD/YYYY').format(
            'MM/DD/YYYY'
          );
        }
        if (x.ActualArchiveDate !== null && x.ActualArchiveDate !== '') {
          x.ActualArchiveDate = moment(x.ActualArchiveDate).format(
            'MM/DD/YYYY'
          );
        }
      });
      return {
        ...state,
        selectedForVerification: action.payload.data,
      };
    case types.SELECTED_FOR_VERIFICATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case types.DECLINE_FOR_VERIFICATION_SUCCESS:
      return {
        ...state,
      };
    case types.SELECTED_FOR_VERIFICATION_AVAILABLE_TO_DECLINE:
      return {
        ...state,
        availableToDecline: action.payload,
      };
    case types.SELECTED_FOR_VERIFICATION_CLEAR_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/selectedforverification/state/reducer.js